import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Logo_gopaperless from "../../assets/images/logos/paperless/gopaperless-logo-darkblue-2.png";

const DeeplinkContent = () => {
   const {t} =useTranslation()
  const [statusText, setStatusText] = useState("");
  const [localT, setLocalT] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code") || "TESTCODE123";
    const state = params.get("state") || "TESTSTATE";

    // --- Lấy ngôn ngữ ---
    let lang =
      localStorage.getItem("lang") ||
      (
        params.get("ui_locales") ||
        params.get("hl") ||
        params.get("lang") ||
        "en"
      ).toLowerCase();

    if (lang.startsWith("vi")) lang = "vi";
    else lang = "en";

    // --- Bản dịch ---
    const i18n = {
      en: {
        title: "Launch GoPaperless Agent",
        opening: "Opening GoPaperless Agent...",
        failed:
          "⚠️ The app didn’t open automatically. Please make sure GoPaperless Agent is installed.",
        notLaunching: "Not launching?",
        clickHere: "Click here instead",
        terms: "Terms of use",
        privacy: "Privacy policy",
      },
      vi: {
        title: "Khởi chạy GoPaperless Agent",
        opening: "Đang mở GoPaperless Agent...",
        failed:
          "⚠️ Ứng dụng chưa mở? Hãy kiểm tra bạn đã cài GoPaperless Agent.",
        notLaunching: "Không tự mở?",
        clickHere: "Nhấn vào đây",
        terms: "Điều khoản sử dụng",
        privacy: "Chính sách bảo mật",
      },
    };

    const textPack = i18n[lang] || i18n.en;
    setLocalT(textPack);
    document.title = textPack.title;

    // --- Tạo deep link ---
    const deepLink = `gopaperless-agent://callback?code=${encodeURIComponent(
      code
    )}&state=${encodeURIComponent(state)}`;

    // --- Khi người dùng vừa vào trang -> auto open ---
    setStatusText(textPack.opening);
    setTimeout(() => {
      window.location.href = deepLink; // 👈 Chrome sẽ show alert ngay tại đây
    }, 400);

    // --- Link thủ công ---
    const manualLink = document.getElementById("manualLink");
    if (manualLink) manualLink.setAttribute("href", deepLink);

    // --- Khi người dùng nhấn Launch ---
    const launchButton = document.getElementById("launchButton");
    if (launchButton) {
      launchButton.addEventListener("click", () => {
        setStatusText(textPack.opening);
        window.location.href = deepLink; // 👈 Show alert khi click Launch
      });
    }

    // Cleanup
    return () => {
      if (launchButton) {
        launchButton.replaceWith(launchButton.cloneNode(true));
      }
    };
  }, []);

  return (
    <div
      id="content"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "white",
        textAlign: "center",
        position: "relative",
        gap: "16px",
      }}
    >
      <img
        src={Logo_gopaperless}
        alt="GoPaperless Logo"
        style={{
          maxWidth: "300px",
          height: "auto",
          display: "block",
          marginBottom: "16px",
        }}
      />

      <button
        id="launchButton"
        className="btn btn-primary rounded-pill px-4 py-2"
        style={{ fontSize: "16px", fontWeight: 500 }}
      >
        {t("gpl_agent.title")}
      </button>

      <p
        style={{
          fontSize: "14px",
          color: "#6c757d",
          marginTop: "8px",
          marginBottom: "0",
        }}
      >
        <span>{t("gpl_agent.notLaunching")} </span>
        <a
          id="manualLink"
          href="#"
          style={{
            color: "#2563eb",
            textDecoration: "none",
          }}
        >
         {t("gpl_agent.clickHere")}
        </a>
      </p>

      <footer
        style={{
          position: "absolute",
          bottom: "16px",
          textAlign: "center",
          fontSize: "14px",
          color: "#6c757d",
          width: "100%",
          backgroundColor: "transparent",
          borderTop: "none",
        }}
      >
        <a
          href="https://gopaperless.vn/uploads/GoPaperless_ChinhSachThuThapVaXuLyDuLieuCaNhan"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#2563eb",
            textDecoration: "none",
            marginRight: "8px",
          }}
        >
        {t("gpl_agent.terms")}
        </a>
        <span style={{ color: "#ccc" }}>|</span>
        <a
          href="https://gopaperless.vn/uploads/GoPaperless_ChinhSachBaoMatThongTin"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#2563eb",
            textDecoration: "none",
            marginLeft: "8px",
          }}
        >
          {t("gpl_agent.privacy")}
        </a>
      </footer>
    </div>
  );
};

export default DeeplinkContent;
